exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table[data-v-4949ebb0]::before {\n  height: 0px!important;\n}\n", ""]);

// exports
